import { render, staticRenderFns } from "./danYuanJianCe.vue?vue&type=template&id=18706ce9&scoped=true&"
import script from "./danYuanJianCe.vue?vue&type=script&lang=js&"
export * from "./danYuanJianCe.vue?vue&type=script&lang=js&"
import style0 from "./danYuanJianCe.vue?vue&type=style&index=0&id=18706ce9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18706ce9",
  null
  
)

export default component.exports